
export const tdStyles = {
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    padding: "5px 10px",
    verticalAlign: "top",
    textAlign: "left"
};


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/monitorStyles.js
 **/